import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { List, Datagrid, TextField, ReferenceField, EditButton, Edit, SimpleForm, ReferenceInput, TextInput, SelectInput, DisabledInput, LongTextInput, Create, Filter } from 'react-admin';

const AdminTitle = ({ record }) => {
	return <span>{record ? `${record.username}` : ''}</span>;
}
const DescriptionField = ({ record = {} }) => {
	console.log(record["description"]["asdf"]);
	return (<span>{record["description"]["asdf"]}</span>);
};

export const SinglePurchaseList = props => (
	<List /*filters={<PostFilter />}*/ {...props} title="관리자">
		<Datagrid>
			<TextField source="id" label="일련번호" />
			<ReferenceField label="상품" source="product_id" reference="product">
				<TextField source="id" />
			</ReferenceField>
		</Datagrid>
	</List>
)